import {
    HttpResponse,
    AiServiceQueueItemModel,
    RequestParams,
    ApiResultFailed,
    Operation,
    AggregationModel,
    AggregationResponse,
    GrouppedQueryModel
} from "@/libs/Api";
import ApiService from "@/libs/core/api-service"
import {CrudDataQuery, CrudService} from '@/libs/core/+state/models/crud-service';
import {CrudEnumerableResponse, CrudResponse} from "../core/+state/models/crud-response";

export class AiServiceQueueItemsDataService implements CrudService<AiServiceQueueItemModel, AiServiceQueueItemModel> {
    getAll(query: CrudDataQuery<AiServiceQueueItemModel>): Promise<CrudEnumerableResponse<AiServiceQueueItemModel>> {
        return ApiService.api.getAiServiceQueueItemBatch(query.pageIndex, query.pageSize, <any>query.data, query.params);
    }

    getBasicAll(query: CrudDataQuery<AiServiceQueueItemModel>): Promise<CrudEnumerableResponse<AiServiceQueueItemModel>> {
        throw new Error('NotImplemented');
    }

    get(id: string, params?: RequestParams): Promise<CrudResponse<AiServiceQueueItemModel>> {
        return ApiService.api.getAiServiceQueueItemById(id, params);
    }

    create(item: AiServiceQueueItemModel, params?: RequestParams): Promise<CrudResponse<AiServiceQueueItemModel>> {
        throw new Error('NotImplemented');
    }

    update(item: AiServiceQueueItemModel, params?: RequestParams): Promise<AiServiceQueueItemModel> {
        throw new Error('NotImplemented');
    }

    partialUpdate(id: string, patches: Operation[], params?: RequestParams): Promise<AiServiceQueueItemModel> {
        throw new Error('NotImplemented');
    }

    delete(query: CrudDataQuery<AiServiceQueueItemModel>): Promise<CrudEnumerableResponse<AiServiceQueueItemModel>> {
        throw new Error('NotImplemented');
    }

    getAggregation(query: AggregationModel, params?: RequestParams): Promise<AggregationResponse> {
        throw new Error('NotImplemented');
    }
    
    download(query: CrudDataQuery<AiServiceQueueItemModel>): Promise<HttpResponse<any, ApiResultFailed | void>> {
        throw new Error('NotImplemented');
    }

    clone(item: AiServiceQueueItemModel, params?: RequestParams): Promise<CrudResponse<AiServiceQueueItemModel>> {
        throw new Error('NotImplemented');
    }

    getGroupped(query: GrouppedQueryModel, params?: RequestParams): Promise<CrudResponse<any>> {
        throw new Error('NotImplemented');
    }

}
